import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Config } from 'dompurify';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);
  
  transform(html: string, params: Config = {}): SafeHtml {
    const sanitized = DOMPurify.sanitize(html, { ...params, RETURN_TRUSTED_TYPE: false });
    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }
}
